"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regex = _interopRequireDefault(require("./regex.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function validate(uuid) {
  return typeof uuid === 'string' && _regex["default"].test(uuid);
}

var _default = validate;
exports["default"] = _default;